import mod from "-!./script.js?vue&type=script&lang=js&"; export default mod; export * from "-!./script.js?vue&type=script&lang=js&"